import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';

export default function TheComp() {
    const { t } = useLang('theProduct.HighlightsA');
    return (
        <>
            <EfImg
                pc="https://websiteoss.ecoflow.com/upload/image/1724561383619/high_light_6.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1724561383619/high_light_6.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1724568991104/high_light_6_h5.jpg"
            />
            <div className="card-box card-box6 card-box-white">
                <div className="card-title">{t('item6_title')}</div>
                <div className="card-desc">{t('item6_desc')}</div>
            </div>
        </>
    );
}
